
<template>
  <div class="divbgcolor" v-if="appUser">
    <v-layout wrap justify-start 
      >
      <v-flex md12 lg12 px-12 class="fontts">
        <v-layout wrap justify-start>
          <v-flex md4 px-lg-10 py-lg-3 pl-12 pl-sm-0 text-left align-self-center>
            <span class="headingsProf">My Profile</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex
            xs4
            md2
            align-self-start
            text-left
            v-if="myprofile.photo == ''"
          >
            <v-img
              :src="require('../../assets/profile.png')"
              contain
              height="270px"
            ></v-img>
          </v-flex>
          <v-flex class="hidden-md-and-down"
            xs4
            md2
            align-self-start
            text-left
            v-if="myprofile.photo !== ''"
          >
            <v-avatar color="primary" size="200px"
            
            >
              <v-img
                :src="mediaURL + myprofile.photo"
                cover
                height="270px"
              ></v-img
            ></v-avatar>
          </v-flex>
           <v-flex pl-12 pl-sm-0 class="hidden-lg-and-up"
            xs4
            md2
            align-self-start
            text-left
            v-if="myprofile.photo !== ''"
          >
            <v-avatar color="primary" size="150px"
            
            >
              <v-img
                :src="mediaURL + myprofile.photo"
                cover
                height="270px"
              ></v-img
            ></v-avatar>
          </v-flex>

          <v-flex md4 lg3 px-1 align-self-center class="weight">
            <v-layout wrap justify-start>
              <v-flex py-1  py-sm-4 xs3 sm2 md3 lg3 align-self-start>
                <span>Name:</span>
              </v-flex>
              <v-flex py-1 py-sm-4 xs5 sm5 md2 lg2 align-self-start>
                <span>{{ myprofile.name }}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex py-1 py-sm-4 xs3 sm2 md3 lg3  align-self-start>
                <span>E-mail:</span>
              </v-flex>
              <v-flex py-1 py-sm-4 xs5 sm5  md2 lg2 align-self-start>
                <span>{{ myprofile.email }}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex py-1 py-sm-4 xs6 sm4 md7 lg5 xs12 align-self-start>
                <span>Phone Number:</span>
              </v-flex>
              <v-flex py-1 py-sm-4 xs2 sm2 md2 lg2 align-self-start>
                <span>{{ myprofile.phone }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex align-self-center md6 lg7>
            <v-layout
              wrap
              py-5
             
              class=""
             
            >
              <v-flex md4 sm4>
                <v-layout wrap justify-center text-center>
                  <v-flex xs12  >
                    <v-img 
                      height="100px"
                      src="../../assets/tur.png"
                      contain
                     
                    ></v-img>
                  </v-flex>
                  <v-flex>
                    <v-layout wrap>
                      <v-flex xs12  >
                        <span class="weight"  > No: of species observed:</span>
                      </v-flex>
                      <v-flex>
                        <span class="weight1" >{{ count }}</span>
                      </v-flex>
                      <v-flex v-if="count == 0">
                        <span class="sub">0</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md4 sm4>
                <v-layout wrap justify-center text-center >
                  <v-flex xs12  >
                    <v-img
                      height="100px"
                      
                      src="../../assets/search.png"
                      contain
                     
                    ></v-img>
                  </v-flex>
                  <v-flex>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <span class="weight"> No: of observations: </span>
                      </v-flex>
                      <v-flex>
                        <span class="weight1">{{ observation.length }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md4 sm4>
                <v-layout wrap justify-center text-center>
                  <v-flex xs12>
                    <v-img
                      contain
                      height="100px"
                      src="../../assets/rescue.png"
                     
                    ></v-img>
                  </v-flex>
                  <v-flex>
                    <v-layout wrap>
                      <v-flex xs12 pt-md-7 pt-lg-0>
                        <span class="weight">No: of rescues: </span>
                      </v-flex>
                      <v-flex >
                        <span class="weight1">{{ rescue.length }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <SightingsInfo />
  </div>
</template>
<script>
import SightingsInfo from "./SightingsInfo";
import store from "../../store";
import axios from "axios";
export default {
  data() {
    return {
      myprofile: [],
      mydata: [],
      rescue: [],
      observation: [],
      count: "",
     
        loading: false,
    };
  },
  computed: {
    appUser() {
      return store.state.isLoggedIn;
    },
  },
  components: {
    SightingsInfo,
  },
  mounted() {
    this.getProfile();
    this.getdata();
    this.loader()
  },
  methods: {
    loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    
    getProfile() {
      axios({
        method: "GET",
        url: "user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.myprofile = response.data.data;
        }
      });
    },
    getdata() {
      axios({
        method: "GET",
        url: "report/mine",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          var Species = [];
          var speciesCount = 0;
          this.mydata = response.data.data;
          for (var i = 0; i < this.mydata.length; i++) {
            if (this.mydata[i].purpose !== "rescue") {
              this.rescue.push(this.mydata[i]);
            } else {
              this.observation.push(this.mydata[i]);
            }
            if (!Species.includes(this.mydata[i].turtle.name)) {
              Species.push(this.mydata[i].turtle.name);
              speciesCount++;
            }
            this.count = speciesCount;
          }
          console.log(this.mydata);
          console.log("rescue=", this.rescue);
          console.log("observation=", this.observation);
          console.log("count=", this.count);
        }
      });
    },
  },
};
</script>